import React, { useEffect } from "react";
import image_main from "../assests/image_main.png";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { Link } from "react-scroll";
import { TypeAnimation } from "react-type-animation";

const Home = () => {
  useEffect(() => {
    const highlightText = () => {
      const textElement = document.querySelector(".highlight-text");
      if (textElement) {
        const wordsToHighlight = [
          "Full Stack Developer",
          "HTML5",
          "CSS3",
          "JavaScript",
          "React",
          "Python",
          "Django",
          "Docker",
          "Looking for a role",
          "Junior Software Developer",
          "Internship",
        ];

        let index = 0;

        const highlightNextWord = () => {
          if (index < wordsToHighlight.length) {
            const word = wordsToHighlight[index];
            const regex = new RegExp(`\\b${word}\\b`, "gi");
            textElement.innerHTML = textElement.innerHTML.replace(
              regex,
              `<span class="highlight">${word}</span>`
            );
            index++;
            setTimeout(highlightNextWord, 2000);
          }
        };

        highlightNextWord();
      }
    };

    highlightText();
  }, []);

  return (
    <div
      name="home"
      id="Home"
      className="h-screen w-full bg-gradient-to-b from-black via-black to-gray-800"
    >
      <div className="max-w-screen-lg mx-auto flex flex-cols-reverse items-center justify-center h-full px-4 md:flex-row">
        <div className="flex flex-col justify-center h-full text-center md:text-left ">
          <h2 className="text-2xl sm:text-5xl md:text-7xl font-bold text-white">
            I'm a
            <TypeAnimation
              sequence={[
                " Junior Full Stack Developer",
                3000,
                " Junior Web Developer",
                3000,
              ]}
              speed={30}
              // repeat={Infinity}
            />
          </h2>
          <p className="text-gray-500 py-4 max-w-md mx-auto md:mx-0 text-sm md:text-lg highlight-text">
            A junior full stack developer, proficient in today’s most used
            technologies and concepts such as HTML5, CSS3, JavaScript, React JS,
            Python, Django, and Docker. Looking for a role as a Junior Software
            Developer or an Internship.
          </p>
          <div className = "flex justify-center md:justify-start">
            <Link
              to="portfolio"
              smooth
              duration={500}
              className="group text-white w-fit px-6 py-3 my-2 flex items-center rounded-md 
            bg-gradient-to-r from-cyan-500 to-blue-500 cursor-pointer"
            >
              Portfolio
              <span className="group-hover:rotate-90 duration-300">
                <MdOutlineKeyboardArrowRight size={25} className="ml-1" />
              </span>
            </Link>
          </div>
        </div>
        <div className ="mb-8 md:mb-0">
          <img
            src={image_main}
            alt="portfolio profile"
            className="rounded-2xl mx-auto w-2/3 sm:w-1/2 md:w-full"
          />
        </div>
      </div>
    </div>
  );
};

export default Home;
